import React, { useEffect, useState } from "react";
import { getAllCollections, getCollectionById } from "../../collections/api";
import ProductGrid from "../../products/components/ProductGrid";
import ProductGridSkeleton from "../../products/components/ProductGridSkeleton";
import HomeSection from "./HomeSection";

const ROW_SIZE = 12;

// Every page of the collections list, so new collections show up without code changes.
const fetchAllCollections = async () => {
  const all = [];
  for (let page = 0, totalPages = 1; page < totalPages; page++) {
    const data = await getAllCollections(page);
    all.push(...(data?.content || []));
    totalPages = data?.totalPages || 1;
  }
  return all;
};

/** One home row per collection: its products in a scrolling row, linking to the collection page. */
const CollectionRow = ({ collection }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    getCollectionById(collection.slug, 0, ROW_SIZE)
      .then((data) => {
        if (!ignore) setProducts(data?.publicProducts?.content || []);
      })
      .catch((error) => console.error(`Error fetching collection ${collection.slug}:`, error))
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [collection.slug]);

  if (!loading && products.length === 0) return null;

  return (
    <HomeSection
      className="trending-products"
      title={collection.displayName}
      action={{ label: "View all", to: `/${collection.type.toLowerCase()}/${collection.slug}` }}
    >
      {loading ? (
        <ProductGridSkeleton count={6} bare variant="row" />
      ) : (
        <ProductGrid products={products} showLoadmore={false} bare variant="row" />
      )}
    </HomeSection>
  );
};

/** Every active collection from the API, each as its own home row, in API order. */
const HomeCollections = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    let ignore = false;
    fetchAllCollections()
      .then((all) => {
        if (!ignore) setCollections(all.filter((c) => c.status === "active" && c.slug && c.type));
      })
      .catch((error) => console.error("Error fetching collections:", error));
    return () => {
      ignore = true;
    };
  }, []);

  return collections.map((collection) => (
    <CollectionRow key={collection.collectionId || collection.slug} collection={collection} />
  ));
};

export default HomeCollections;
